export const SpinnerIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM1.52 8a6.48 6.48 0 1 0 12.96 0A6.48 6.48 0 0 0 1.52 8Z"
    />
    <defs>
      <radialGradient
        id="a"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 8 -8 0 8 8)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D5BFF" />
        <stop offset={1} stopColor="#02DE7F" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);
